module.exports = __webpack_public_path__ + "img/startup-info-employes.03ac1ff3.svg";